export default __webpack_public_path__ + "static/media/capitol_building_washington_dc.32861c45.jpg";